import React from 'react';
import { SearchFormResults } from './SearchFormResults';
import { CollapsibleWysiwygView } from '../../../_lib/components/Wysiwyg';
import { FetchType } from '../../../types/api/FetchType';
import { FACETS } from '../../../components/molecules/ResultListSettings/ResultListSettings.enums';
import ResultListSettings from '../../../components/molecules/ResultListSettings/ResultListSettings';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import { SearchResults } from '../../../types/Search.types';
import { SearchFormSwitchButtons } from './SearchFormSwitchButtons';
import { SearchFormBase, SearchFormModifier } from './SearchFormBase';

type SearchFormProps = {
  searchResult: SearchResults;
  type: 'content' | 'user';
  showSwitchButtons?: boolean;
  wantedFacets: FACETS[];
  modifier?: Modifier<SearchFormModifier>;
};

export function SearchForm({ searchResult, type, showSwitchButtons, wantedFacets, modifier }: SearchFormProps) {
  return (
    <SearchFormBase
      idPrefix={type}
      modifier={modifier}
      minLength={2}
      maxLength={searchResult.maxLength}
      fqPathId={searchResult.sectionFilter?.sectionParams?.fq_pathId}
      hasUnsupportedSonSearchFeatures={searchResult.hasUnsupportedSonSearchFeatures}
      searchFormResults={<SearchFormResults searchResult={searchResult} pageList={modifier === 'page-list'} />}
      initialQueryParameter={searchResult.term}
    >
      {showSwitchButtons && <SearchFormSwitchButtons searchLinks={searchResult.searchLinks || {}} currentType={type} />}
      {searchResult.richtext && (
        <div className="search-form__help-text">
          <CollapsibleWysiwygView
            fetchType={FetchType.instant}
            href={searchResult.searchForm.url}
            embedded={searchResult.richtext}
          />
        </div>
      )}
      {searchResult.facets ? (
        <ResultListSettings
          searchStrictness={searchResult.searchStrictness}
          facets={searchResult.facets}
          sort={searchResult.sort}
          filter={searchResult.filter}
          resetAllFiltersUrl={searchResult.resetAllFiltersUrl}
          wantedFacets={wantedFacets}
        />
      ) : null}
    </SearchFormBase>
  );
}
